import { InvestmentStatus } from '@inversor-hub/types';

export const investmentStatusLabelMap: Record<InvestmentStatus, string> = {
  PURCHASING: 'En proceso de compra',
  RENOVATING: 'En reforma',
  LISTED_FOR_RENT_OR_SALE: 'Anunciado para alquiler/venta',
  RENTED: 'Alquilado',
  SOLD: 'Vendido',
};
